module.exports = __webpack_public_path__ + "static/medusa-459fb4ca94c5183a94067984f99918c9.png";